<template>
    <div :class="copyClass">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            isCenter: { type: Boolean, default: false },
            size: { type: String, default: undefined },
        },

        computed: {
            copyClass() {
                return {
                    'page-copy': true,
                    'page-copy--is-center': this.isCenter,
                    [`page-copy--size-${this.size}`]: this.size,
                }
            },
        },
    }
</script>
